"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RouteType = void 0;
var RouteType;
(function (RouteType) {
    RouteType[RouteType["Car"] = 0] = "Car";
    RouteType[RouteType["Ship"] = 1] = "Ship";
    RouteType[RouteType["Spaceship"] = 2] = "Spaceship";
})(RouteType || (exports.RouteType = RouteType = {}));
//# sourceMappingURL=RouteType.js.map